import { theme } from "@common/dev/tailwind.config.cjs"
import { useMediaQuery } from "@common/hooks/useMediaQuery"
import { useEffect, useState } from "react"

const useIsMobile = () => {
  const matches = useMediaQuery(`(max-width:${theme.screens.md})`)
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    setIsMobile(matches)
  }, [matches])
  return isMobile
}

export default useIsMobile
